export default __webpack_public_path__ + "static/media/jason-thumb.8b045df6.png";